/**
 * Simple events manager.
 */

var Events = function() {
    this.events = {};
};

Events.prototype = {
    constructor: Events,
    events: undefined,
    /**
     * 
     * @param {string} names 
     * @param {closure} cb 
     */
    on: function(names, cb) {
        var self = this;
        names.split(' ').forEach(function(name) {
            if (!self.events[name]) {
                self.events[name] = {
                    handlers: [],
                    active: new Map()
                };
            }
            if (!self.events[name].active.has(cb)) {
                self.events[name].active.set(cb, true);
                self.events[name].handlers.push(cb);
            }
            else if (self.events[name].active.has(cb)) {
                self.events[name].active.set(cb, true);
            }
        });
    },
    /**
     * 
     * @param {string} names 
     * @param {closure} cb 
     */
    off: function(names, cb) {
        var self = this;
        names.split(' ').forEach(function(name) {
            if (self.events[name]) {
                if (self.events[name].active.has(cb)) {
                    self.events[name].active.set(cb, false);
                }
            }
        });
    },
    /**
     * 
     * @param {string} names 
     * @param {object} data 
     */
    fire: function(names, data) {
        var self = this;
        names.split(' ').forEach(function(name) {
            if (self.events[name]) {
                self.events[name].handlers.forEach(function(handler) {
                    if (self.events[name].active.get(handler)) {
                        handler(data);
                    }
                });
            }
        });
    }
};

module.exports = Events;